import BigNumber from "bignumber.js";
export default function (el, binding) {
    let price = binding.value
    if (price === '' || price === undefined || price === null) {
        el.innerText = ''
        return
    }
    const args = binding.arg
    price = new BigNumber(price).toFixed(2)
    if (price.indexOf('.') > 0) {
        const priceList = price.split('.')
        price = parseInt(priceList[0]) + '.' + priceList[1]
        if (args && args === 'locale') {
            price = parseInt(priceList[0]).toLocaleString() + '.' + priceList[1]
        }
    } else {
        price = parseInt(price) + '.00'
        if (args && args === 'locale') {
            price = parseInt(price).toLocaleString() + '.00'
        }
    }
    el.innerText = price
}
